import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { HttpRequestService } from 'src/app/core/services';

@Component({
  selector: 'app-delete-requests',
  templateUrl: './delete-requests.component.html',
  styleUrls: ['./delete-requests.component.scss'],
})
export class DeleteRequestsComponent implements OnInit {
  deleteRequests: any[] = [];
  totalDataCount = 0;
  pageSize = 12;
  pageIndex = 1;
  loading = false;
  searchRequest: Subject<string> = new Subject<string>();
  search = '';
  skipIndex: number = 0;

  constructor(
    private httpRequestService: HttpRequestService,
    private notificationService: NzNotificationService,
  ) {}

  ngOnInit(): void {
    this.searchRequest.pipe(debounceTime(1000)).subscribe((success: string) => {
      this.search = success;
      this.pageIndex = 1;
      this.skipIndex = 0;
      this.getAllDeleteRequests();
    });
    this.getAllDeleteRequests();
  }

  /* Get all delete requests */
  getAllDeleteRequests(skip = 0, sortBy?: any): void {
    let params: any;
    params = { skip: this.skipIndex, limit: this.pageSize };
    if (this.search) {
      params.search = this.search;
    } else {
      delete params.search;
    }

    if (sortBy) {
      params.sortBy = JSON.stringify(sortBy);
    }
    this.loading = true;
    this.httpRequestService
      .request('get', 'users/delete-requests', params)
      .subscribe(
        (result) => {
          this.loading = false;
          this.deleteRequests = result.data;
          this.totalDataCount = result.totalCount;
        },
        (err) => {
          this.loading = false;
        },
      );
  }

  /* For Pagination / Sending skip */
  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex } = params;
    this.skipIndex = pageSize * (pageIndex - 1);
    this.getAllDeleteRequests(pageSize * (pageIndex - 1));
  }

  /* Accept delete request */
  acceptDeleteRequest(id: string, isAccepted: boolean): void {
    this.httpRequestService
      .request('put', `users/delete-requests/accept-reject/${id}`, {
        isAccepted: isAccepted,
      })
      .subscribe(
        (result: any) => {
          this.notificationService.success(
            '',
            'Delete Request Accepted Successfully',
          );
          this.getAllDeleteRequests();
        },
        (error) => {
          this.notificationService.error(
            '',
            error?.error?.message || 'Failed to accept request',
          );
        },
      );
  }

  /* Search delete requests */
  searchDeleteRequests(event: any): void {
    this.searchRequest.next(event);
  }
}
